export function convertToPlain(html: any) {
  const tempDivElement = document.createElement('div');

  tempDivElement.innerHTML = html;

  return tempDivElement.innerText.replace(/\n/g, ' ') || '';
}
